import React from 'react';
import { CommonPrelander } from '../../components/CommonPrelander';
import { QUIZ_SLIDES_V27 } from '../../shared/quiz-slides/quiz-slides-v27';

function PrelanderV46Page({ initialPrelander }) {
    return (
        <CommonPrelander
            initialPrelander={initialPrelander}
            quizSlides={QUIZ_SLIDES_V27}
        />
    );
}

export {
    PrelanderV46Page
};
